// Firebase configuration for Chipless
import { initializeApp } from 'firebase/app';
import { getDatabase, connectDatabaseEmulator } from 'firebase/database';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBs-gQGg0M-JJAj7JDdRWFrFHy7W47juKk",
  authDomain: "chipless-v2-77638.firebaseapp.com",
  databaseURL: "https://chipless-v2-77638-default-rtdb.firebaseio.com",
  projectId: "chipless-v2-77638",
  storageBucket: "chipless-v2-77638.firebasestorage.app",
  messagingSenderId: "944767063121",
  appId: "1:944767063121:web:33f9e9fe7f303dbfe41470"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Realtime Database and get a reference to the service
export const database = getDatabase(app);

// Local e2e / helpers. Production and Hosting preview builds omit this env.
if (process.env.REACT_APP_FIREBASE_EMULATOR === '1') {
  connectDatabaseEmulator(database, '127.0.0.1', 9000);
}

export default app; 